import React, { useState } from "react"
import { MessageCircle, X } from "lucide-react"

import { FAQ } from "@/types/chatbot"
import { useChat } from "@/hooks/use-chat"
import { Button } from "@/components/ui/button"
import { Card, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { ChatMessages } from "@/components/chat/chat-messages"

import { FAQs } from "./faqs"

export const ChatHead: React.FC = () => {
  const { chatState, toggleChat, addMessage, addMessages } = useChat()
  const [input, setInput] = useState("")

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setInput("")
    if (input.trim()) {
      await addMessage(input, "user")
    }
  }

  const handleFAQClick = (faq: FAQ) => {
    const timestamp = new Date().toISOString()

    addMessages([
      {
        id: Date.now().toString(),
        content: faq.question,
        sender: "user",
        created_at: timestamp,
        updated_at: timestamp,
      },
      {
        id: (Date.now() + 1).toString(),
        content: faq.answer,
        sender: "bot",
        created_at: timestamp,
        updated_at: timestamp,
      },
    ])
  }

  return (
    <>
      {/* Mobile Chathead */}
      <div className="fixed bottom-4 right-4 z-50 md:hidden">
        <Button
          onClick={toggleChat}
          size="icon"
          className="rounded-full shadow-lg"
        >
          <MessageCircle className="h-6 w-6" />
        </Button>
      </div>

      {/* Desktop Tab */}
      <div className="fixed bottom-0 right-4 z-50 hidden md:block">
        <Button
          onClick={toggleChat}
          className="rounded-b-none rounded-t-lg px-6 shadow-lg"
        >
          Chat with HIMO
        </Button>
      </div>

      {/* Chat Box */}
      {chatState.isOpen && (
        <Card className="fixed bottom-0 right-0 z-50 flex h-[calc(100vh-4rem)] w-full flex-col md:h-[45rem] md:w-[30rem]">
          <div className="flex flex-row items-center justify-between px-4 pt-2">
            <CardTitle className="text-lg">HIMO Chat</CardTitle>
            <Button variant="ghost" size="icon" onClick={toggleChat}>
              <X className="h-4 w-4" />
            </Button>
          </div>
          <div className="flex flex-1 flex-col overflow-hidden">
            <FAQs onQuestionClick={handleFAQClick} />
            <div className="flex-1 overflow-hidden">
              <ChatMessages messages={chatState.messages} />
            </div>
          </div>
          <div className="px-4 pb-4">
            <form onSubmit={handleSubmit} className="flex w-full space-x-2">
              <Input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="Type your message..."
                className="flex-1"
              />
              <Button type="submit">Send</Button>
            </form>
          </div>
        </Card>
      )}
    </>
  )
}
